import React from 'react';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

// Components
import ToolbarPopupTool from '../../ToolbarPopupTool';
import Icon from '../../../../../components/icons/Icon';
import TableCellAlignmentToolbarPopup from './TableCellAlignmentToolbarPopup';
import useTableCellAlignmentToolState from './useTableCellAlignmentToolState';

// Constants
import { PopupIds, PopupSections } from '../../../../../components/popupPanel/popupConstants';

type TableCellAlignmentToolProps = Record<string, unknown> & {
    element?: ImMNElement;
};

const TableCellAlignmentTool: React.FC<TableCellAlignmentToolProps> = (props) => {
    const { commonTextAlignment, commonVerticalAlignment, isDisabled } = useTableCellAlignmentToolState();

    return (
        <ToolbarPopupTool
            {...props}
            name="Alignment"
            popupId={PopupIds.TABLE_CELL_ALIGNMENT_TOOL}
            closeSection={PopupSections.TOOLBAR}
            toolName={'CellAlignment'}
            disabled={isDisabled}
            buttonSelector=".CellalignmentTool .icon"
            PopupComponent={TableCellAlignmentToolbarPopup}
            preventFocus
            // @ts-ignore Struggling with the JSX type inference
            active={false}
            commonTextAlignment={commonTextAlignment}
            commonVerticalAlignment={commonVerticalAlignment}
        >
            <Icon name={`toolbar-align-${commonTextAlignment?.toLowerCase() || 'justified'}`} />
        </ToolbarPopupTool>
    );
};

export default TableCellAlignmentTool;
